<script>
    export let value = null;
    export let pill = true;
    export let showIcon = true;
    export let onClick = (event, value) => console.log(value)

    function handleBadgeClick(event){
        if(!showIcon){
            onClick(event, value);
        }
    }
</script>

<style>
    .badge {
        background-color: #dee2e6;
        color: #454545;
        padding: 5px 10px;
        margin-right: 10px;
        margin-bottom: 3px;
        margin-top: 3px;
    }

    .clickable {
        cursor: pointer;
    }

    .badge:hover {
        background-color: #dd5900;
        color: white;
    }

    .fas {
        margin-left: 3px;
        cursor: pointer;
    }
</style>

{#if value}
    <span 
        class="badge" 
        class:clickable={!showIcon}
        class:badge-pill={pill}
        on:click={handleBadgeClick}>
        {typeof value === 'string' ? value : value.name}
        {#if showIcon}
        <i 
            on:click={event => onClick(event, value)}
            class="fas fa5-times-circle"></i>
        {/if}
    </span>
{/if}